import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
// import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import { StoreContextProvider } from './Context/store'


ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
      {/* <StoreContextProvider> */}
        
      {/* </StoreContextProvider> */}

    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
